"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNetworkErrorTranslationPaths = getNetworkErrorTranslationPaths;

var _compact2 = _interopRequireDefault(require("lodash/compact"));

var _camelCase2 = _interopRequireDefault(require("lodash/camelCase"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Export `getNetworkErrorTranslationPaths`.
 */
function getNetworkErrorTranslationPaths(errorCode, basePath) {
  var code = (0, _camelCase2["default"])(errorCode);
  return (0, _compact2["default"])([basePath && "".concat(basePath, ".network.").concat(code), "defaultErrors.network.".concat(code), basePath && "".concat(basePath, ".network.defaultError"), 'defaultErrors.network.defaultError']);
}